import React, { useState } from 'react'
import AddProjectDetails from '../project/AddProjectDetails'
const EmpProjects = () => {

    const [projectData, setProjectData] = useState([])

    return (
        <div>
            <AddProjectDetails />
        </div>
    )
}

export default EmpProjects